import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')``;

export const Title = styled('div')`
  font-weight: 700;
  font-size: 16px;
  color: ${theme.palette.text.dark};
`;

export const Legend = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;

  .item {
    font-size: 12px;
    color: ${theme.palette.text.dark};
    display: inline-flex;
    align-items: center;

    .mark {
      width: 8px;
      height: 8px;
      border-radius: 100%;
      margin-right: 8px;
    }
  }
`;

export const ChartWrapper = styled('div')`
  width: 100%;
  height: 290px;
  margin-top: 24px;
`;
